import { iterateRules, RuleDefinition, RuleDefinitionType } from '../ruleDefinition';

export function getConditionFields(condition: RuleDefinition) {
	return [...iterateRules(condition)]
		.filter((part) => part.type == RuleDefinitionType.Rule && part.properties?.field)
		.map((part) => part.properties.field);
}
